module.exports = __webpack_public_path__ + "img/bes.b551016f.svg";